import { ActivitySpinnerSize, ActivitySpinnerWidget } from '@tableau/widgets';
import * as React from 'react';

import { CommonStyles } from '../../commonInfra/styles/CommonStyles';
import { sanitize } from '../../commonInfra/utils/Sanitize';

import { CommandSuggestionIconSize } from '../common/Constants';
import { setupUIBindingForReactFunctionalComponent } from '../common/UIBindingForReact';
import { CommandSuggestionViewModel } from '../viewModels/CommandSuggestionViewModel';
import { activeSectionItem, alignCenter, contentSuggestionSectionItem, contentSuggestionSectionItemContent, contentSuggestionSectionItemIcon, section, sectionItem, sectionItemAutoFitContent, sectionItemFixedContent, sectionItemHorizontalLayout, useColorForHighlight } from './OmniboxV2Styles';

export const CommandSuggestionTestId = 'CommandSuggestion';

export function CommandSuggestion(props: { viewModel: CommandSuggestionViewModel }): JSX.Element {
    const viewModel = props.viewModel;
    setupUIBindingForReactFunctionalComponent(viewModel);

    return renderCommandSuggestionItems(viewModel);
}

export function renderCommandSuggestionItems(viewModel: CommandSuggestionViewModel): JSX.Element {
    return (!viewModel.commandSuggestionItems || viewModel.commandSuggestionItems.length > 0) ? <div data-tb-test-id={CommandSuggestionTestId} className={[ section, 'tb-quicklinks-section-divider', (viewModel.omniboxViewModel.shouldUseColorHighlight() ? useColorForHighlight : null)].join(' ')}>
        {
            viewModel.commandSuggestionItems ? viewModel.commandSuggestionItems.map((item, index) => {
                const icon = item.icon;
                return <a id={item.getIdentifier()} key={index} href={item.url} role='option' aria-selected={item === viewModel.currentKeyboardNavigableItem}
                    onClick={(event) => { event.preventDefault(); event.stopPropagation(); viewModel.onItemClicked(item, index); }}
                    className={[sectionItem, sectionItemHorizontalLayout, contentSuggestionSectionItem, (item === viewModel.currentKeyboardNavigableItem ? activeSectionItem : '')].join(' ')}>
                    <div className={[sectionItemFixedContent, contentSuggestionSectionItemIcon].join(' ')}>
                        <img width={CommandSuggestionIconSize} height={CommandSuggestionIconSize} src={`data:image/svg+xml,${encodeURIComponent(icon)}`} alt="Accessible Description" />
                    </div>
                    <div className={[sectionItemAutoFitContent, contentSuggestionSectionItemContent].join(' ')}>
                        <div className={sectionItemHorizontalLayout}>
                            <div className={sectionItemAutoFitContent} style={{ position: 'relative', height: 21 }}>
                                <div className={sectionItemHorizontalLayout} style={{ position: 'absolute', width: '100%' }}>
                                    <div style={{ ...CommonStyles.Layout.TextEllipsis }} dangerouslySetInnerHTML={{
                                        __html:
                                            sanitize(item.command)
                                    }}></div>

                                </div>
                            </div>
                        </div>
                    </div>
                </a>;
            })
                : <div className={alignCenter} style={{ height: '134px' }}>
                    <ActivitySpinnerWidget
                        spinnerSize={ActivitySpinnerSize.Small}
                        testId={'omnibox-pending'}
                    />
                </div>
        }
    </div>
        : null;
}
